import React, { useEffect, useState } from 'react';
import { Input, Message } from 'rsuite';
import { Button, Modal, useLastPresent } from '@nsi-advisory-services/components';

// The confirm step for submitting, approving, returning or reopening a pay
// period. Returning needs a comment - the person has to know what to fix - so
// `commentRequired` holds the button until there is one.
export default function PeriodActionModal({
  open,
  onClose,
  onConfirm,
  title,
  children = null,
  confirmLabel = 'Confirm',
  confirmColor = null,
  commentLabel = 'Comment',
  commentPlaceholder = '',
  commentRequired = false,
  showComment = true,
  loading = false,
  error = null,
}) {
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (open) setComment('');
  }, [open]);

  const blocked = commentRequired && !comment.trim();

  // What the dialog says is frozen once it starts to close, so its text holds
  // while it fades out after the caller clears whatever opened it.
  const shown = useLastPresent(
    open ? { title, children, confirmLabel, confirmColor, commentLabel, commentPlaceholder, commentRequired, showComment } : null
  ) || { title, children, confirmLabel, confirmColor, commentLabel, commentPlaceholder, commentRequired, showComment };

  return (
    <Modal open={open} onClose={onClose} size="xs">
      <Modal.Header>
        <Modal.Title>{shown.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="bdc-modal__fields">
          {shown.children}
          {error ? <Message type="error" showIcon>{error}</Message> : null}
          {shown.showComment ? (
            <>
              <label className="bdc-modal__label" htmlFor="ts-period-comment">
                {shown.commentLabel}{shown.commentRequired ? '' : ' (optional)'}
              </label>
              <Input
                id="ts-period-comment"
                as="textarea"
                rows={3}
                value={comment}
                onChange={setComment}
                placeholder={shown.commentPlaceholder}
              />
            </>
          ) : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant={shown.confirmColor === 'red' ? 'danger-solid' : 'primary'}
          onClick={() => onConfirm(comment.trim())}
          disabled={blocked}
          loading={loading}
        >
          {shown.confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
